import * as PapaParse from 'papaparse';
import { SSOUserImportRow } from '../../api/users';

export interface ParsedSSOUser extends SSOUserImportRow {
  valid: boolean;
  validationError?: string;
  selectedForImport: boolean;
  rowIndex: number;
}

export const SSO_CSV_TEMPLATE_HEADERS = ['externalUserId', 'role', 'givenName', 'familyName', 'email'];

export const SSO_CSV_TEMPLATE_CONTENT =
  SSO_CSV_TEMPLATE_HEADERS.join(',') +
  '\n' +
  'auth0|example123,Viewer,Jane,Doe,jane.doe@example.com\n' +
  'auth0|example456,Editor,John,Smith,john.smith@example.com\n';

export const parseCSVToSSOUsers = (csvInput: string, validRoleNames?: Set<string>): ParsedSSOUser[] => {
  const rows = PapaParse.parse<Record<string, string>>(csvInput, {
    header: true,
    skipEmptyLines: true,
  }).data;

  return rows.map((row, index) => {
    const externalUserId = (row['externalUserId'] ?? '').trim();
    const role = (row['role'] ?? '').trim();

    const email = (row['email'] ?? '').trim();

    const errors: string[] = [];
    if (!externalUserId) errors.push('externalUserId required');
    if (!role) errors.push('role required');
    else if (validRoleNames && !validRoleNames.has(role)) errors.push(`role "${role}" not found in account`);
    if (!email) errors.push('email required');

    const valid = errors.length === 0;
    return {
      externalUserId,
      role,
      givenName: (row['givenName'] ?? '').trim() || undefined,
      familyName: (row['familyName'] ?? '').trim() || undefined,
      email,
      valid,
      validationError: valid ? undefined : errors.join('; '),
      selectedForImport: valid,
      rowIndex: index + 1,
    };
  });
};
